import firebase from "@/firebase";
import db from "@/db";
import store from "@/store";
import router from "@/router";

const state = {
  user: {},
  referral: "",
  contest: [false, false, false, false],
};

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    db.collection("users")
      .doc(user.uid)
      .get()
      .then((doc) => {
        const data = doc.data();
        data.id = user.uid;
        //store.commit("user/setUser", data);
        //store.dispatch("user/setUserGroups");
      });
  } else {
    store.commit("user/setUser", null);
  }
});

const mutations = {
  setUser(state, user) {
    if (user) {
      state.user = user;
      state.user.allGroups = [
        ...state.user.courses,
        ...state.user.faculties,
        ...state.user.groups,
        ...state.user.directMessages,
      ];
      //state.user = state.user.filter((v, i, a) => a.indexOf(v) === i);
      if (!user.course_ids) {
        state.user.course_ids = [];
        state.user.faculty_ids = [];
        state.user.group_ids = [];
        state.user.dm_ids = [];
        if (state.user.directMessages) {
          state.user.directMessages.forEach((dm) => {
            state.user.dm_ids.push(dm.id);
          });
        } else {
          state.user.directMessages = [];
        }
        if (state.user.courses) {
          state.user.courses.forEach(async (course) => {
            state.user.course_ids.push(course.id);
          });
        } else {
          state.user.courses = [];
        }
        if (state.user.groups) {
          state.user.groups.forEach((group) => {
            state.user.group_ids.push(group.id);
          });
        } else {
          state.user.groups = [];
        }
        if (state.user.faculties) {
          state.user.faculties.forEach((faculty) => {
            state.user.faculty_ids.push(faculty.id);
          });
        } else {
          state.user.faculties = [];
        }
      }
    } else {
      state.user = {};
    }
  },

  setReferral(state, referral) {
    state.referral = referral;
  },

  setContest(state, contest) {
    state.contest = contest;
  },

  setCourses(state, courses) {
    state.user.courses = courses;
  },

  setFaculties(state, faculties) {
    state.user.faculties = faculties;
  },

  setGroups(state, groups) {
    state.user.groups = groups;
  },
};

const actions = {
  logout({ state }) {
    firebase.auth().signOut();
    state.user = {};
    router.push({
      name: "Login",
    });
  },

  async setUserGroups({ state }) {
    state.user.courses.forEach((course, index) => {
      db.collection("courses")
        .doc(course.id)
        .get()
        .then((doc) => {
          state.user.courses[
            index
          ].hasSeenLastPost = doc.data().hasSeenLastPost;
          state.user.courses[index].recentPosts = doc.data().recentPosts;
          state.user.courses[index].userCount = doc.data().userCount;
          state.user.courses[index].school_id = doc.data().school_id;
          state.user.courses[index].users = doc.data().users;
          state.user.courses[index].profileImage = doc.data().profileImage;
          state.user.courses[index].type = "courses";
        });
    });
    state.user.directMessages.forEach((dm, index) => {
      db.collection("directMessages")
        .doc(dm.id)
        .get()
        .then((doc) => {
          state.user.directMessages[
            index
          ].hasSeenLastPost = doc.data().hasSeenLastPost;
          state.user.directMessages[index].name = doc
            .data()
            .users.find((user) => user.user_id !== state.user.id).name;
          state.user.directMessages[index].profileImage = doc
            .data()
            .users.find((user) => user.user_id !== state.user.id).profileImage;
          state.user.directMessages[index].recentPosts = doc.data().recentPosts;
          state.user.directMessages[index].type = "directMessages";
        });
    });
    state.user.groups.forEach((group, index) => {
      db.collection("groups")
        .doc(group.id)
        .get()
        .then((doc) => {
          state.user.groups[index].hasSeenLastPost = doc.data().hasSeenLastPost;
          state.user.groups[index].name = doc.data().name;
          state.user.groups[index].recentPosts = doc.data().recentPosts;
          state.user.groups[index].userCount = doc.data().userCount;
          state.user.groups[index].school_id = doc.data().school_id;
          state.user.groups[index].type = "groups";
        });
    });
    state.user.faculties.forEach((faculty, index) => {
      db.collection("faculties")
        .doc(faculty.id)
        .get()
        .then((doc) => {
          state.user.faculties[
            index
          ].hasSeenLastPost = doc.data().hasSeenLastPost;
          state.user.faculties[index].name = doc.data().name;
          state.user.faculties[index].recentPosts = doc.data().recentPosts;
          state.user.faculties[index].userCount = doc.data().userCount;
          state.user.faculties[index].school_id = doc.data().school_id;
          state.user.faculties[index].type = "faculties";
        });
    });
    state.user.loaded = true;
  },

  updateUserGroups({ commit, state }) {
    var courses = [];
    var faculties = [];
    var groups = [];
    var directMessages = [];
    let user = state.user;
    user.courses = user.courses.filter(
      (v, i, a) => a.findIndex((x) => x.id === v.id) === i
    );
    user.groups = user.groups.filter(
      (v, i, a) => a.findIndex((x) => x.id === v.id) === i
    );
    user.faculties = user.faculties.filter(
      (v, i, a) => a.findIndex((x) => x.id === v.id) === i
    );
    user.directMessages = user.directMessages.filter(
      (v, i, a) => a.findIndex((x) => x.id === v.id) === i
    );
    commit("setUser", user);
    state.user.courses.forEach((course) => {
      const courseDoc = {
        name: course.name,
        subject: course.subject,
        id: course.id,
        lastVisited: course.lastVisited,
        notificationsEnabled: course.notificationsEnabled,
      };
      courses.push(courseDoc);
    });
    state.user.faculties.forEach((faculty) => {
      const facultyDoc = {
        name: faculty.name,
        id: faculty.id,
        lastVisited: faculty.lastVisited,
        notificationsEnabled: faculty.notificationsEnabled,
      };
      faculties.push(facultyDoc);
    });
    state.user.groups.forEach((group) => {
      const groupDoc = {
        name: group.name,
        id: group.id,
        lastVisited: group.lastVisited,
        notificationsEnabled: group.notificationsEnabled,
      };
      groups.push(groupDoc);
    });
    state.user.directMessages.forEach((dm) => {
      const dmDoc = {
        name: dm.name,
        id: dm.id,
        lastVisited: dm.lastVisited,
        notificationsEnabled: dm.notificationsEnabled,
      };
      directMessages.push(dmDoc);
    });

    db.collection("users")
      .doc(state.user.id)
      .update({
        courses: courses,
        faculties: faculties,
        groups: groups,
        directMessages: directMessages,
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
